import { useQuery, gql } from '@apollo/client';

export const GET_PLATFORM_COMPANY_DEPARTMENTS = gql`
  query getPlatformCompanyDepartments {
    getPlatformCompanyDepartments {
      _id
      companyId
      companyBusinessAddressId
      name
      costCenter
    }
  }
`;

export const useGetPlatformCompanyDepartments = () => {
  const { data, loading } = useQuery(GET_PLATFORM_COMPANY_DEPARTMENTS, {
    fetchPolicy: 'network-only',
  });

  return {
    companyDepartments: data?.getPlatformCompanyDepartments || [],
    loading,
  };
};
